var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    ref: "audioPlayer",
    attrs: {
      "id": "audioHolder",
      "autoplay": "",
      "controls": "",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mediaPath,
      "type": "audio/mpeg"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.errors.audioTagError')) + "\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34dab0c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contentViewer/contentHelper/audioPlayer.vue
// module id = 3nNa
// module chunks = 1